import IndexTableRow from '@lib/components/index-table/IndexTableRow';
import HistoryChanges from '../common/HistoryChanges';

export default class AuditTableRow extends IndexTableRow {
    constructor(props) {
        super(props)
    }

    renderChangedEntitiesColumn = (column, value) => {
        return <td>
            <ul>{HistoryChanges(value.changes)}</ul>
        </td>
    }
}